import * as R from 'ramda'
import debug from 'debug'
import url from 'url'

import { serveRedirect, removeSession } from 'src/lib/response'
import logger from 'util/logger'

import errorsSlice from 'src/store/errors/slice'

const log = debug('yd:redux-middleware')

const handleErrorRedirects = errorData => {
  const { error, ':yd-anom/message': message } = errorData || {}

  const redirect = encodeURIComponent(
    `${window.location.pathname}${window.location.search}`
  )

  if (error === 'expired-session') {
    removeSession(null, '/user/login')
    return true
  }

  if (error === 'invalid-session') {
    removeSession(null, '/user/login')
    return true
  }

  if (error === 'not-authorized' || message === 'Invalid CSRF Token') {
    const redirectUrl = url.format({
      pathname: '/user/not-authorized',
      query: { redirect }
    })
    removeSession(null, redirectUrl)
    return true
  }

  if (error === 'pending-network-invitation') {
    const redirectUrl = url.format({
      pathname: '/organization/invitation',
      query: { redirect }
    })

    serveRedirect(null, {}, redirectUrl)
    return true
  }

  if (error === 'user-not-verified') {
    serveRedirect(null, {}, '/user/verification')
    return true
  }
}

const handleErrorData = errorData => {
  log('handle error', errorData)
  const { error } = errorData

  if (error === 'request-timeout') {
    return errorData
  }

  if (error === 'query-timeout') {
    return errorData
  }

  if (error === 'bad-query') {
    return errorData
  }

  if (error === 'not-a-network') {
    return errorData
  }

  if (error === 'invalid-network') {
    return errorData
  }

  if (handleErrorRedirects(errorData)) {
    return
  }

  return logger.log(JSON.stringify(errorData))
}

const errorHandleMiddleware = _ => next => action => {
  try {
    return next(action)
  } catch (error) {
    const { response, code, crossDomain, status } = error
    if (code === 'ECONNREFUSED' || (!status && crossDomain)) {
      const { address, port } = error
      return next(
        errorsSlice.actions.setErrors({
          interception: {
            error: 'connection-refused',
            cause: { address, port }
          },
          error
        })
      )
    }

    const errorCode = R.pathOr(null, ['body', 'error'], response)

    if (errorCode) {
      const errorObject = {
        interception: handleErrorData(response.body),
        error
      }
      return next(errorsSlice.actions.setErrors(errorObject))
    }
    throw error
  }
}

export default errorHandleMiddleware
